import {testIdProps} from '@github-ui/test-id-props'
import {BlockedIcon} from '@primer/octicons-react'
import {Token} from '@primer/react'
import {graphql, useFragment} from 'react-relay'

import type {IssueItemBlockedBy$key} from './__generated__/IssueItemBlockedBy.graphql'
import type {IssueRowSecondaryQuery$data} from './__generated__/IssueRowSecondaryQuery.graphql'
import styles from './IssueItem.module.css'

type Props = {
  listItemMetadata?: IssueRowSecondaryQuery$data | null
  issueId: string
  getIssueTypeHref?: () => string
}

// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-queries
const issueBlockedByFragment = graphql`
  fragment IssueItemBlockedBy on Issue {
    state
    issueDependenciesSummary {
      blockedBy
    }
  }
`

export function IssueItemBlockedBy({listItemMetadata, issueId, getIssueTypeHref}: Props) {
  if (!listItemMetadata) return null

  const issueNode = listItemMetadata.nodes?.find(node => node?.id === issueId)

  if (!issueNode) return null

  return <IssueItemBlockedByInternal blockedByKey={issueNode} getIssueTypeHref={getIssueTypeHref} />
}

export function IssueItemBlockedByInternal({
  blockedByKey,
  getIssueTypeHref,
}: {
  blockedByKey?: IssueItemBlockedBy$key
  getIssueTypeHref?: () => string
}) {
  const data = useFragment(issueBlockedByFragment, blockedByKey)

  if (data?.state === 'CLOSED') return null

  if (!data?.issueDependenciesSummary) return null

  const {blockedBy} = data.issueDependenciesSummary

  if (blockedBy === 0) return null
  const href = getIssueTypeHref?.() ?? undefined

  return (
    <Token
      text="Blocked"
      leadingVisual={() => <BlockedIcon className="fgColor-danger" size={14} />}
      className={styles.token}
      {...(href ? {as: 'a', href} : {})}
      {...testIdProps('blocked-by-token')}
    />
  )
}
